import React from "react";

import { Scope } from "@/common";
import { SearchProps } from "@/components/Search";
import Button, { ButtonIntent } from "@imminently/decisively-ui/Button";
import Icon from "@imminently/decisively-ui/Icon";
import TextInput from "@imminently/decisively-ui/TextInput";

// TODO page header might instead take children as a function and pass down search, sort and filter

export type PageHeaderProps = {
  title: string;
  /** Rendered before primary `actions` (e.g. help icon next to “Add …”). */
  actionAdornment?: React.ReactNode;
  actions?: { name: string; intent?: ButtonIntent; onClick?: () => void }[];
  scope?: boolean;
  search?: SearchProps;
  scopeComponent?: any;
  children?: React.ReactNode;
};

export const PageHeader = ({
  title,
  actionAdornment,
  actions,
  scope,
  children,
  search,
  scopeComponent,
}: PageHeaderProps) => {
  const searchEl = search
    ? (() => {
        const { value, setValue, placeholder, icon, onClear, noSetValueOnClear, ...searchInputProps } = search as any;
        const hideClear = (search as any).hideClear;

        return (
          <TextInput
            {...searchInputProps}
            className="w-85"
            value={value}
            placeholder={typeof placeholder === "string" ? placeholder : ""}
            onValueChange={setValue}
            startAdornment={icon ?? <Icon name="search" />}
            clearable={!hideClear}
            onClear={noSetValueOnClear ? onClear : undefined}
          />
        );
      })()
    : null;

  return (
    <div className="common-page-header flex flex-col px-8 pt-8 mb-5 [&>*:not(:last-child)]:mb-4">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-6">
          <h1 className="text-4xl font-bold">{title}</h1>
          {scope && (
            <div>
              {/* @ts-ignore - Can type Scope later */}
              {scopeComponent ? React.createElement(scopeComponent) : <Scope />}
            </div>
          )}
        </div>
        <div className="flex flex-row flex-nowrap gap-4">
          {actionAdornment}
          {actions &&
            actions.map(({ name, intent, ...rest }) => (
              <Button
                label={name}
                key={name}
                intent={intent}
                {...rest}
              >
                {name}
              </Button>
            ))}
        </div>
        {children}
      </div>
      {searchEl && <div className="flex items-center justify-between">{searchEl}</div>}
    </div>
  );
};
